var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('form-users-workspace',{attrs:{"editable":_vm.editable,"user_id":_vm.$route.params.id,"workspace_id":_vm.$route.params.workspace_id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }